import "react-simple-keyboard/build/css/index.css";
import { useState } from "react";
import Keyboard from "react-simple-keyboard";
import { FaBars } from "react-icons/fa6";
import logo from "../assets/logo.png";
import logo2 from "../assets/logo2.png";
import Button from "../common/Button";
import Info from "./Info";
import { IoChevronForward } from "react-icons/io5";
import useQuizStore from "../store/quiz";

const Play = ({
  id,
  values,
  layout,
  quiz,
  clue,
  setClue,
  score,
  inputsRef,
  setIsModified,
  handleFocus,
  handleClick,
  handleKeyDown,
  handleCheckAnswer,
  adjustScoreAndAttempt,
  revealLetter,
  highlightedQuestion,
  getFocusIndex,
  setHighlighted,
}) => {
  const [showInfo, setShowInfo] = useState(false);
  const { getClueStatus, setClueStatus } = useQuizStore();

  return (
    <div className="h-screen overflow-hidden">
      {showInfo && <Info handleShow={() => setShowInfo(false)} />}
      <div className="mx-auto max-w-[630px] px-2 md:px-6 py-1 w-full">
        <div className="flex justify-between items-center">
          <a href="/">
            <img
              src={logo}
              alt="Sporting Cryptic"
              className="size-14 bg-white rounded-full"
            />
          </a>
          <div
            className="size-10 cursor-pointer rounded-full grid place-items-center bg-primary"
            onClick={() => setShowInfo(true)}
          >
            <FaBars
              size={20}
              fill="white"
            />
          </div>
        </div>
        <p
          className="my-5 text-center"
          dangerouslySetInnerHTML={{ __html: highlightedQuestion || quiz?.question }}
        />
      </div>
      <div className="h-[calc(100%_-_160px)] md:h-[calc(100%_-_128px)]">
        <div className="w-full h-full">
          <div className="flex flex-col justify-between h-full relative">
            <div className="absolute right-1">
              <div className="flex flex-col gap-1.5 items-end [&>button]:!text-sm [&>button]:!py-1 [&>button]:px-4 [&>button]:!flex [&>button]:!items-center [&>button]:!gap-1">
                {quiz?.clue1 && (
                  <Button
                    className="!bg-primary2"
                    onClick={() => {
                      adjustScoreAndAttempt("clue");
                      setClueStatus(id, "clue1");
                      setClue(id, `Clue 1: ${quiz?.clue1}`);
                      setHighlighted(id, quiz?.highlight1);
                      setIsModified(prev => prev + 1);
                    }}
                    disabled={getClueStatus(id, "clue1")}
                  >
                    <img
                      src={logo2}
                      className="bg-white rounded-full size-4"
                      alt=""
                    />
                    Clue1{" "}
                    <IoChevronForward
                      fill="var(--main)"
                      size={18}
                    />
                  </Button>
                )}
                {quiz?.clue2 && (
                  <Button
                    className="!bg-primary2"
                    onClick={() => {
                      adjustScoreAndAttempt("clue");
                      setClueStatus(id, "clue2");
                      setClue(id, `Clue 2: ${quiz?.clue2}`);
                      setHighlighted(id, quiz?.highlight2);
                      setIsModified(prev => prev + 1);
                    }}
                    disabled={getClueStatus(id, "clue2")}
                  >
                    <img
                      src={logo2}
                      className="bg-white rounded-full size-4"
                      alt=""
                    />
                    Clue2{" "}
                    <IoChevronForward
                      fill="var(--main)"
                      size={18}
                    />
                  </Button>
                )}
                {quiz?.clue3 && (
                  <Button
                    className="!bg-primary2"
                    onClick={() => {
                      adjustScoreAndAttempt("clue");
                      setClueStatus(id, "clue3");
                      setClue(id, `Clue 3: ${quiz?.clue3}`);
                      setHighlighted(id, quiz?.highlight3);
                      setIsModified(prev => prev + 1);
                    }}
                    disabled={getClueStatus(id, "clue3")}
                  >
                    <img
                      src={logo2}
                      className="bg-white rounded-full size-4"
                      alt=""
                    />
                    Clue3{" "}
                    <IoChevronForward
                      fill="var(--main)"
                      size={18}
                    />
                  </Button>
                )}
                {values.filter(v => v !== null && v !== "").length !==
                  values.filter(v => v !== null).length && (
                  <Button
                    className="!bg-secondary"
                    onClick={revealLetter}
                  >
                    <img
                      src={logo2}
                      className="bg-white rounded-full size-4"
                      alt=""
                    />
                    Letter{" "}
                    <IoChevronForward
                      fill="var(--main)"
                      size={18}
                    />
                  </Button>
                )}
                {values.filter(v => v !== null && v !== "").length ===
                  values.filter(v => v !== null).length && (
                  <Button onClick={handleCheckAnswer}>
                    <img
                      src={logo2}
                      className="bg-white rounded-full size-4"
                      alt=""
                    />
                    Check answer{" "}
                    <IoChevronForward
                      fill="var(--main)"
                      size={18}
                    />
                  </Button>
                )}
              </div>
            </div>
            <div className="h-full max-w-[630px] mx-auto px-1 md:px-6">
              <div className="grid place-items-center h-full">
                <div className="flex items-center justify-center gap-x-2 gap-y-3 flex-wrap">
                  {values.map((value, index) => (
                    <>
                      {value === null ? (
                        <div className="w-full"></div>
                      ) : (
                        <input
                          key={index}
                          type="text"
                          value={value || ""}
                          maxLength="1"
                          className={`size-11 text-2xl text-white lowercase cursor-pointer text-center p-1 font-semibold rounded-md shadow-[-4px_4px_0px_0px_black] ${getFocusIndex(id) === index ? "bg-yellow-400" : "bg-primary"}`}
                          ref={el => (inputsRef.current[index] = el)}
                          onFocus={() => handleFocus(index)}
                          onClick={() => handleClick(index)}
                          readOnly
                        />
                      )}
                    </>
                  ))}
                </div>
              </div>
            </div>
            <div>
              <div className="max-w-[630px] mx-auto px-1 md:px-6">
                {clue && <p className="text-center mb-3 text-xl font-semibold text-red-500">{clue}</p>}
                <div className="flex items-end justify-center gap-3 mb-4">
                  <span className="text-sm leading-none">Your Score:</span>
                  <div className="flex items-center gap-2">
                    {Array.from({ length: 11 }, (_, idx) => 10 - idx).map(number => (
                      <div
                        key={number}
                        className="flex flex-col gap-1 items-center"
                      >
                        <span className="text-xs">{number}</span>
                        <div
                          className={`size-3 rounded-full border-[1.5px] border-main ${number >= score ? "bg-primary" : ""}`}
                        />
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              <div className="bg-secondary">
                <div className="max-w-[630px] mx-auto px-1 md:px-6 py-1">
                  <Keyboard
                    layout={layout}
                    onKeyPress={handleKeyDown}
                    layoutName="default"
                    display={{ "{bksp}": "⌫" }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Play;
